import { render, staticRenderFns } from "./v-tree-select-multiple.vue?vue&type=template&id=10f04983&"
import script from "./v-tree-select-multiple.vue?vue&type=script&lang=js&"
export * from "./v-tree-select-multiple.vue?vue&type=script&lang=js&"
import style0 from "./v-tree-select-multiple.vue?vue&type=style&index=0&lang=sass&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VOverlay,VProgressCircular,VTreeview})
